import { ErrorToast } from "../../shared/index";
function ErrorHandlingAPI(data) {
  data.Errors.forEach((element) => {
    ErrorToast(element.ErrorMessage);
  });
}
export default ErrorHandlingAPI;
